/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type InternalGetBulkMetricDiagnosticsPathParams = NonNullable<
  operations['internalGetBulkMetricDiagnostics']['parameters']['path']
>;

export type InternalGetBulkMetricDiagnosticsQueryParams = NonNullable<
  operations['internalGetBulkMetricDiagnostics']['parameters']['query']
>;

export interface Input extends InternalGetBulkMetricDiagnosticsPathParams {
  apiVersion?: string;
  query: InternalGetBulkMetricDiagnosticsQueryParams;
}

export async function internalGetBulkMetricDiagnostics(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projectKey}/environments/{envKey}/metrics/diagnostics/bulk', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
